<template>
  <v-col>
    <v-row no-gutters>
      <div class="grey--text">
        <div>{{ $langs.MyStore.editStoreManageYourStoreInformation[$langs.lang] }}</div>
      </div>
    </v-row>
    <v-divider class="mt-2 bold-1"></v-divider>

    <v-form ref="form" :disabled="loading" @submit.prevent="updateStoreInfo()">
      <v-row no-gutters class="pt-3">
        <!-- คอลัมซ้าย -->
        <v-col cols="12" sm="7">
          <v-row no-gutters>
            <!--บรรทัด 1-->
            <v-col cols="12">
              <h3>{{ $langs.MyStore.storeName[$langs.lang] }}</h3>
              <v-text-field
                label=""
                :disabled="disabledRename"
                :persistent-hint="disabledRename"
                v-model="STORE.storeName"
                :hint="
                  disabledRename
                    ? `Can be renamed in ${
                        RENAME_STORE_INTERVAL - durationSinceRename
                      } days`
                    : `Store name can be renamed 1 time per month`
                "
              ></v-text-field>

              <h3 class="mt-10">{{ $langs.MyStore.storeLocation[$langs.lang] }}</h3>
            </v-col>

            <!--บรรทัด 2-->
            <v-col class="px-1" cols="3">
              <v-text-field
                label="เลขที่"
                v-model="STORE.address.no"
              ></v-text-field>
            </v-col>

            <v-col class="px-1" cols="5">
              <v-text-field
                label="อาคาร/หมู่บ้าน"
                v-model="STORE.address.building"
              ></v-text-field>
            </v-col>

            <v-col class="px-1" cols="4">
              <v-text-field
                label="ซอย"
                v-model="STORE.address.soi"
              ></v-text-field>
            </v-col>

            <!--บรรทัด 3-->
            <v-col class="px-1" cols="2">
              <v-text-field
                label="หมู่"
                v-model="STORE.address.moo"
              ></v-text-field>
            </v-col>

            <v-col class="px-1" cols="5">
              <v-text-field
                label="ถนน"
                v-model="STORE.address.road"
              ></v-text-field>
            </v-col>

            <v-col class="px-1" cols="5">
              <v-text-field
                label="ตำบล"
                v-model="STORE.address.subdistrict"
              ></v-text-field>
            </v-col>

            <!--บรรทัด 4-->
            <v-col class="px-1" cols="6">
              <v-text-field
                label="อำเภอ"
                v-model="STORE.address.district"
              ></v-text-field>
            </v-col>

            <v-col class="px-1" cols="6">
              <v-autocomplete
                v-model="STORE.address.province"
                :items="PROVINCES"
                item-text="province"
                item-value="province"
                label="จังหวัด"
                hide-no-data
                :rules="[(v) => !!v || 'required']"
              ></v-autocomplete>
            </v-col>

            <!--บรรทัด 5-->
            <v-col class="px-1" cols="4">
              <v-text-field
                label="รหัสไปรษณีย์"
                v-model="STORE.address.zipCode"
                :rules="[(v) => !v || /^[0-9]*$/.test(v) || 'Number Only']"
              ></v-text-field>
            </v-col>
          </v-row>
        </v-col>

        <!-- คอลัมขวา -->
        <v-col cols="12" sm="5" class="px-3">
          <h3>{{ $langs.MyStore.storeContact[$langs.lang] }}</h3>

          <!--บรรทัด 1-->
          <v-text-field label="Telephone" v-model="STORE.contact.tel"></v-text-field>

          <v-text-field
            label="Facebook"
            v-model="STORE.contact.fb"
          ></v-text-field>

          <v-text-field
            label="Line"
            v-model="STORE.contact.line"
          ></v-text-field>

          <v-text-field
            label="Website"
            v-model="STORE.contact.web"
          ></v-text-field>

          <v-text-field
            label="Store Email"
            v-model="STORE.contact.email"
          ></v-text-field>

          <h3>{{ $langs.MyStore.aboutStore[$langs.lang] }}</h3>

          <v-textarea
            :label="$langs.Gen.description[$langs.lang]"
            no-resize
            counter="2000"
            class="mt-2"
            v-model="STORE.description"
          ></v-textarea>
        </v-col>
      </v-row>

      <v-row no-gutters class="justify-end px-3 mt-3">
        <v-btn
          color="primary"
          type="submit"
          :ripple="false"
          :disabled="!change"
          :loading="loading"
          >{{ $langs.Gen.save[$langs.lang] }}</v-btn
        >
      </v-row>
    </v-form>
  </v-col>
</template>

<script>
import store from "../../services/store";
import api from "../../services/api";

export default {
  props: ["store", "logoImage"],
  data() {
    return {
      STORE: {
        address: {},
        contact: {},
        description: "",
        logoImage: "",
        sellerAccount: {},
        status: {},
        storeName: "",
        user: "",
        _id: "",
      },
      strStore: "",

      fileSize: 0,
      loading: false,
      compressingImage: false,
      change: false,
      PROVINCES: require("@/assets/data/provinces.json"),
      MAX_LOGO_SIZE: 2,
      RENAME_STORE_INTERVAL: 30,
    };
  },
  mounted() {
    // Not sure if this is necessary
    if (this.store) {
      this.STORE = this.store;
      this.strStore = JSON.stringify(this.store);
    }
  },
  methods: {
    async updateStoreInfo() {
      if (!this.$refs.form.validate()) return;
      if (this.fileSize > this.MAX_LOGO_SIZE)
        return api.makeAlert(
          `Logo image is too large. (more than ${this.MAX_LOGO_SIZE} MB)`,
          "error"
        );
      if (!this.change) return api.makeAlert("No data change", "error");

      // SHOULD SIMPLIFY THIS FORMDATA BY USING FOR-LOOP
      let formData = new FormData();
      if (Object.keys(this.STORE.contact).length) {
        formData.append("contact", JSON.stringify(this.STORE.contact));
      }
      if (Object.keys(this.STORE.address).length) {
        formData.append("address", JSON.stringify(this.STORE.address));
      }
      if (this.STORE.storeName != JSON.parse(this.strStore).storeName) {
        formData.append("storeName", this.STORE.storeName);
      }
      if (this.STORE.description) {
        formData.append("description", this.STORE.description);
      }
      if (this.STORE.logoImage || this.compressingImage) {
        // Show as loading
        this.loading = true;
        while (this.compressingImage)
          await new Promise((r) => setTimeout(r, 50));

        // Add new compressd file to formData
        formData.append("logoImage", this.STORE.logoImage);
      }

      // SEND AN UPDATE
      this.loading = true;
      let { success, msg } = await store.updateStoreInfo(formData);
      this.loading = false;
      if (!success) return api.makeAlert(`Error, ${msg}`, "error");
      api.makeAlert("Saved", "success");

      // NOTE!
      // THIS IS A SIMPLEFY RELOAD STORE INFO BY EMITTING CHANGE
      // TO PARENT AND RELOADING STORE WITHIN 'PARENT' (NOT IN THIS FILE)
      this.$emit("change");
    },
  },
  computed: {
    durationSinceRename() {
      if (!this.store.createdAt) return 0;
      if (!this.store.storeNameUpdatedAt) return Number.MAX_SAFE_INTEGER;
      return parseInt(
        (new Date() - new Date(this.store.storeNameUpdatedAt)) / (24 * 3600000)
      );
    },
    disabledRename() {
      return this.durationSinceRename < this.RENAME_STORE_INTERVAL;
    },
  },
  watch: {
    logoImage() {
      this.change = true;
    },
    store(_store) {
      if (_store) {
        this.STORE = _store;

        // Catch store to 'strStore'
        this.strStore = JSON.stringify(_store);
      }
    },
    "store.logoImage": function (logoImage) {
      this.compressingImage = logoImage == "";
    },
    STORE: {
      handler(_store) {
        let store = JSON.parse(JSON.stringify(_store));
        // Remove Empty field for Comparison
        for (let k of ["address", "contact"])
          for (let key in store[k]) if (!store[k][key]) delete store[k][key];
        this.change = JSON.stringify(store) != this.strStore;
      },
      deep: true,
    },
  },
};
</script>

<style>
</style>